/*
 * Totallager – Offertlista (V2)
 * ---------------------------------------------------------------
 * Fristående motor för offertlistan. Rör inte varukorgen och rör
 * inte quote-modal.js – den befintliga offertmodalen återanvänds
 * som den är via [data-quote-button].
 *
 * Lagring: localStorage. Inget konto krävs, inga minimikrav.
 * Nyckel: tl_quote_list_v1
 */
(function () {
  'use strict';

  var KEY = 'tl_quote_list_v1';
  var VAT = 1.25;
  var MAX_QTY = 999;

  /* ---------------------------------------------------------- */
  /* Lagring                                                     */
  /* ---------------------------------------------------------- */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.items)) return [];
      return data.items;
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items }));
    } catch (e) {
      /* privat läge / full disk – listan blir då bara sessionsbaserad */
    }
    broadcast(items);
  }

  function broadcast(items) {
    document.dispatchEvent(
      new CustomEvent('tl:quotelist:change', { detail: { items: items } })
    );
  }

  function totalQty(items) {
    var sum = 0;
    for (var i = 0; i < items.length; i++) sum += items[i].qty;
    return sum;
  }

  function totalPrice(items) {
    var sum = 0;
    for (var i = 0; i < items.length; i++) sum += items[i].price * items[i].qty;
    return sum;
  }

  /* ---------------------------------------------------------- */
  /* Publikt API                                                 */
  /* ---------------------------------------------------------- */

  var API = {
    items: read,

    add: function (item) {
      var items = read();
      var existing = null;
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].vid) === String(item.vid)) existing = items[i];
      }
      if (existing) {
        existing.qty = Math.min(MAX_QTY, existing.qty + item.qty);
      } else {
        items.push(item);
      }
      write(items);
      return items;
    },

    setQty: function (vid, qty) {
      var items = read();
      var next = [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].vid) === String(vid)) {
          items[i].qty = Math.max(1, Math.min(MAX_QTY, parseInt(qty, 10) || 1));
        }
        next.push(items[i]);
      }
      write(next);
      return next;
    },

    remove: function (vid) {
      var items = read();
      var next = [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].vid) !== String(vid)) next.push(items[i]);
      }
      write(next);
      return next;
    },

    clear: function () {
      write([]);
      return [];
    },

    count: function () {
      return totalQty(read());
    }
  };

  window.TLQuoteList = API;

  /* ---------------------------------------------------------- */
  /* Formatering                                                 */
  /* ---------------------------------------------------------- */

  function money(oren) {
    var kr = Math.round(oren / 100);
    try {
      return new Intl.NumberFormat('sv-SE').format(kr) + ' kr';
    } catch (e) {
      return kr + ' kr';
    }
  }

  function moneyIncl(oren) {
    return money(oren * VAT);
  }

  /* ---------------------------------------------------------- */
  /* Headerikon + räknare                                        */
  /* ---------------------------------------------------------- */

  function paintCount(items) {
    var count = totalQty(items);
    var nodes = document.querySelectorAll('[data-quote-count]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      node.textContent = count > 99 ? '99+' : String(count);
      if (count > 0) {
        node.removeAttribute('hidden');
      } else {
        node.setAttribute('hidden', '');
      }
    }
  }

  function bumpCount() {
    var nodes = document.querySelectorAll('[data-quote-count]');
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        node.classList.remove('tl-qlist-count--bump');
        /* tvinga omstart av animationen */
        void node.offsetWidth;
        node.classList.add('tl-qlist-count--bump');
        window.setTimeout(function () {
          node.classList.remove('tl-qlist-count--bump');
        }, 500);
      })(nodes[i]);
    }
  }

  /* ---------------------------------------------------------- */
  /* "Pling" – flyg till ikonen                                  */
  /* ---------------------------------------------------------- */

  /* Returnerar true om animationen startade. Gör den inte det –
     dold ikon, nollstora element eller prefers-reduced-motion –
     måste anroparen pulsa räknaren själv, annars uteblir kvittensen. */
  function fly(sourceEl, imageUrl) {
    var target = document.querySelector('[data-quote-list-icon]');
    if (!target || !sourceEl) return false;

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return false;

    var from = sourceEl.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return false;

    var ghost = document.createElement('div');
    ghost.className = 'tl-qlist-ghost';
    if (imageUrl) {
      var img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      ghost.appendChild(img);
    } else {
      ghost.classList.add('tl-qlist-ghost--dot');
    }

    ghost.style.left = from.left + from.width / 2 + 'px';
    ghost.style.top = from.top + from.height / 2 + 'px';
    document.body.appendChild(ghost);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    /* nästa frame, annars hinner ingen transition starta */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        ghost.style.transform =
          'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) scale(0.15)';
        ghost.style.opacity = '0.2';
      });
    });

    window.setTimeout(function () {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      bumpCount();
    }, 650);

    return true;
  }

  /* ---------------------------------------------------------- */
  /* Lägg till från produktsidan                                 */
  /* ---------------------------------------------------------- */

  function variantsFor(productId) {
    var holder = document.querySelector(
      '[data-quote-variants="' + productId + '"]'
    );
    if (!holder) return [];
    try {
      return JSON.parse(holder.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function handleAdd(button) {
    var productId = button.getAttribute('data-product-id');
    var form = button.closest('form');
    var variants = variantsFor(productId);

    var vid = button.getAttribute('data-default-variant');
    var qty = 1;

    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) vid = idInput.value;
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && qtyInput.value) qty = parseInt(qtyInput.value, 10) || 1;
    }

    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(vid)) variant = variants[i];
    }
    if (!variant && variants.length) variant = variants[0];
    if (!variant) return;

    var item = {
      vid: variant.id,
      pid: productId,
      title: button.getAttribute('data-product-title') || '',
      variant: variant.title && variant.title !== 'Default Title' ? variant.title : '',
      sku: variant.sku || '',
      price: typeof variant.price === 'number' ? variant.price : 0,
      url: button.getAttribute('data-product-url') || '',
      img: variant.img || button.getAttribute('data-product-image') || '',
      qty: Math.max(1, Math.min(MAX_QTY, qty))
    };

    API.add(item);

    /* Flyg från produktbilden om den finns, annars från knappen */
    var source =
      document.querySelector('.product-media-gallery img') ||
      document.querySelector('.product__media img') ||
      button;
    if (!fly(source, item.img)) bumpCount();

    /* Kvittens i knappen */
    var label = button.querySelector('[data-quote-add-label]');
    if (label && !button.dataset.tlBusy) {
      var original = label.textContent;
      button.dataset.tlBusy = '1';
      button.classList.add('tl-qlist-add--done');
      label.textContent = 'Tillagd i offertlistan';
      window.setTimeout(function () {
        label.textContent = original;
        button.classList.remove('tl-qlist-add--done');
        delete button.dataset.tlBusy;
      }, 2000);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quote_list_add',
      quote_list_sku: item.sku,
      quote_list_count: API.count()
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-quote-list-add]');
    if (!button) return;
    event.preventDefault();
    handleAdd(button);
  });

  /* ---------------------------------------------------------- */
  /* Listsidan                                                   */
  /* ---------------------------------------------------------- */

  function lineText(items) {
    var rows = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var row = i + 1 + '. ' + it.qty + ' st - ' + it.title;
      if (it.variant) row += ' (' + it.variant + ')';
      if (it.sku) row += ' - SKU ' + it.sku;
      row += ' - ' + money(it.price) + '/st ex moms';
      rows.push(row);
    }
    return rows.join('\n');
  }

  function renderList(root) {
    var items = read();
    var body = root.querySelector('[data-quote-list-body]');
    var empty = root.querySelector('[data-quote-list-empty]');
    var summary = root.querySelector('[data-quote-list-summary]');
    if (!body) return;

    if (!items.length) {
      body.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      if (summary) summary.setAttribute('hidden', '');
      return;
    }

    if (empty) empty.setAttribute('hidden', '');
    if (summary) summary.removeAttribute('hidden');

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var line = it.price * it.qty;
      html +=
        '<li class="tl-qlist-row" data-vid="' + it.vid + '">' +
        '<div class="tl-qlist-row__media">' +
        (it.img
          ? '<img src="' + it.img + '" alt="" loading="lazy" width="72" height="72">'
          : '<span class="tl-qlist-row__placeholder"></span>') +
        '</div>' +
        '<div class="tl-qlist-row__info">' +
        '<a class="tl-qlist-row__title" href="' + (it.url || '#') + '">' +
        escapeHtml(it.title) +
        '</a>' +
        (it.variant
          ? '<span class="tl-qlist-row__meta">' + escapeHtml(it.variant) + '</span>'
          : '') +
        (it.sku
          ? '<span class="tl-qlist-row__meta">Art.nr ' + escapeHtml(it.sku) + '</span>'
          : '') +
        '</div>' +
        '<div class="tl-qlist-row__qty">' +
        '<button type="button" class="tl-qlist-step" data-quote-step="-1" aria-label="Minska antal">&minus;</button>' +
        '<input type="number" class="tl-qlist-qty" value="' + it.qty + '" min="1" max="' + MAX_QTY + '" inputmode="numeric" aria-label="Antal" data-quote-qty>' +
        '<button type="button" class="tl-qlist-step" data-quote-step="1" aria-label="Öka antal">+</button>' +
        '</div>' +
        '<div class="tl-qlist-row__price">' +
        '<span class="tl-qlist-row__price-main">' + money(line) + '</span>' +
        '<span class="tl-qlist-row__price-vat">' + moneyIncl(line) + ' inkl moms</span>' +
        '</div>' +
        '<div class="tl-qlist-row__actions">' +
        '<button type="button" class="tl-qlist-cart" data-quote-to-cart title="Lägg i varukorgen i stället" aria-label="Flytta ' +
        escapeHtml(it.title) +
        ' till varukorgen">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.5a2 2 0 0 0 2-1.55L20.5 8H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20" r="1.4" fill="currentColor"/><circle cx="17" cy="20" r="1.4" fill="currentColor"/></svg>' +
        '</button>' +
        '<button type="button" class="tl-qlist-remove" data-quote-remove aria-label="Ta bort ' +
        escapeHtml(it.title) +
        ' ur listan">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '</div>' +
        '</li>';
    }
    body.innerHTML = html;

    var sum = totalPrice(items);
    var label =
      items.length + (items.length === 1 ? ' artikel' : ' artiklar') +
      ', ' + totalQty(items) + ' st';

    var sumEl = root.querySelector('[data-quote-total]');
    var sumVatEl = root.querySelector('[data-quote-total-vat]');
    var countEl = root.querySelector('[data-quote-total-count]');
    if (sumEl) sumEl.textContent = money(sum);
    if (sumVatEl) sumVatEl.textContent = moneyIncl(sum) + ' inkl moms';
    if (countEl) countEl.textContent = label;

    /* Håll offertknappens etikett aktuell – modalen läser attributet vid klick */
    var quoteButton = root.querySelector('[data-quote-button]');
    if (quoteButton) {
      quoteButton.setAttribute('data-product-title', 'Offertlista – ' + label);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function stampField(form, name, value) {
    var field = form.querySelector('input[name="' + name + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    /* setAttribute krävs för att värdet ska överleva modalens form.reset() */
    field.setAttribute('value', value);
    field.value = value;
  }

  /* ---------------------------------------------------------- */
  /* Flytta rad till varukorgen                                  */
  /* ---------------------------------------------------------- */

  /* "Lägg i varukorgen i stället" – raden läggs i den vanliga varukorgen
     och tas därefter bort ur offertlistan. Kunden ska inte riskera att
     få både en offert och en order på samma artikel. */

  /* Varukorgslådan renderas serverside vid sidladdning. Lägger vi till en
     vara med /cart/add.js utan att säga till temat står lådan kvar och visar
     "Din varukorg är tom" – och då finns ingen kassaknapp heller.

     Temats kontrakt (avläst ur cart-drawer/cart-count i temat):
       • document-eventet 'cart:refresh' får lådan att hämta om sin sektion.
         Den serverrenderade markupen får då rätt tom/ifylld-läge automatiskt.
         detail.open === true öppnar lådan samtidigt.
       • headerns räknare ligger UTANFÖR den sektionen och måste sättas här.

     Använd INTE FoxTheme.pubsub cartUpdate: temats cart-items läser
     event.cart.sections[...] och kastar TypeError om payloaden kommer från
     /cart.js i stället för Section Rendering API:t. */

  function paintThemeCartCount(cart) {
    var nodes = document.querySelectorAll('cart-count');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
      nodes[i].hidden = cart.item_count === 0;
    }
    document.documentElement.classList[cart.item_count > 0 ? 'add' : 'remove']('cart-has-items');
  }

  function refreshThemeCart(openDrawer) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        paintThemeCartCount(cart);
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { detail: { open: openDrawer === true } })
        );
      })
      .catch(function () { /* varan ligger ändå i korgen */ });
  }

  function moveToCart(vid, qty, button) {
    if (button.disabled) return;
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(
            (result.data && (result.data.description || result.data.message)) ||
            'Artikeln kunde inte läggas i varukorgen.'
          );
        }
        API.remove(vid);
        refreshThemeCart(true);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'quote_list_to_cart',
          quote_list_qty: qty
        });
      })
      .catch(function (err) {
        button.disabled = false;
        window.alert(err.message);
      });
  }

  function initListPage() {
    var root = document.querySelector('[data-quote-list-page]');
    if (!root) return;

    renderList(root);
    document.addEventListener('tl:quotelist:change', function () {
      renderList(root);
    });

    root.addEventListener('click', function (event) {
      var target = event.target;

      var toCart = target.closest('[data-quote-to-cart]');
      if (toCart) {
        var cartRow = toCart.closest('.tl-qlist-row');
        var cartQty = cartRow.querySelector('[data-quote-qty]');
        moveToCart(
          cartRow.getAttribute('data-vid'),
          parseInt(cartQty.value, 10) || 1,
          toCart
        );
        return;
      }

      var remove = target.closest('[data-quote-remove]');
      if (remove) {
        API.remove(remove.closest('.tl-qlist-row').getAttribute('data-vid'));
        return;
      }

      var step = target.closest('[data-quote-step]');
      if (step) {
        var row = step.closest('.tl-qlist-row');
        var input = row.querySelector('[data-quote-qty]');
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-quote-step'), 10);
        if (next < 1) {
          API.remove(row.getAttribute('data-vid'));
        } else {
          API.setQty(row.getAttribute('data-vid'), next);
        }
        return;
      }

      var clear = target.closest('[data-quote-clear]');
      if (clear) {
        if (window.confirm('Vill du tömma offertlistan?')) API.clear();
        return;
      }
    });

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-quote-qty]');
      if (!input) return;
      API.setQty(input.closest('.tl-qlist-row').getAttribute('data-vid'), input.value);
    });

    /* Stämpla offertformuläret när kunden begär offert på listan */
    var quoteButton = root.querySelector('[data-quote-button]');
    if (quoteButton) {
      quoteButton.addEventListener('click', function () {
        var form = document.getElementById('quote-contact-form');
        if (!form) return;
        var items = read();
        stampField(form, 'contact[Källa]', 'Offertlista');
        stampField(form, 'contact[Offertlista]', lineText(items));
        stampField(form, 'contact[Ordervärde]', money(totalPrice(items)) + ' ex moms');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'quote_list_request',
          quote_source: 'offertlista',
          quote_list_items: items.length,
          quote_list_value: Math.round(totalPrice(items) / 100)
        });
      });
    }
  }

  /* ---------------------------------------------------------- */
  /* Placering                                                   */
  /* ---------------------------------------------------------- */

  /* Headerikonen renderas i sektionen quote-list-global inuti en dold värd
     och flyttas hit intill varukorgsikonen. Alternativet vore att redigera
     header.liquid (100 kB) – mer risk vid temauppdateringar.

     Produktknappen behöver ingen flytt längre: snippets/quote-button.liquid
     renderar den direkt på den gamla offertknappens plats, alltså redan
     inuti produktformuläret där closest('form') hittar variant och antal. */

  function relocate() {
    var iconHost = document.querySelector('[data-quote-list-icon-host]');
    if (iconHost) {
      var icon = iconHost.querySelector('[data-quote-list-icon]');
      var cart = document.querySelector('a.cart-drawer-button');
      if (icon && cart && cart.parentNode) {
        cart.parentNode.insertBefore(icon, cart);
      } else if (icon) {
        var fallback = document.querySelector('.header__icons, .header__actions');
        if (fallback) fallback.appendChild(icon);
      }
    }
  }

  /* ---------------------------------------------------------- */
  /* Start                                                       */
  /* ---------------------------------------------------------- */

  function init() {
    relocate();
    paintCount(read());
    document.addEventListener('tl:quotelist:change', function (event) {
      paintCount(event.detail.items);
    });
    /* Synka mellan flikar */
    window.addEventListener('storage', function (event) {
      if (event.key === KEY) broadcast(read());
    });
    initListPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
